import { render, staticRenderFns } from "./ProductDisposal.vue?vue&type=template&id=589637fd"
import script from "./ProductDisposal.vue?vue&type=script&lang=js"
export * from "./ProductDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports